import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const QuotationReferenceRowSkeleton = ({ rowIndex = 0, isProjectScoped = false }) => (
  <div className={`quote-reference-row quote-skeleton-row ${rowIndex % 2 === 0 ? "row-even" : "row-odd"}`}>
    <div className="quote-ref-cell"><span><Skeleton width={130} height={14} /></span></div>
    <div className="quote-customer-cell"><Skeleton width="70%" height={13} /></div>
    {!isProjectScoped && <div className="quote-project-name-cell"><Skeleton width="88%" height={13} /></div>}
    <div className="quote-sales-cell"><Skeleton width={100} height={13} /></div>
    <div className="quote-date-cell"><Skeleton width={86} height={13} /></div>
    <div className="amount-cell"><Skeleton width={82} height={13} /></div>
    <div className="quote-status-cell"><Skeleton width={118} height={22} /></div>
    <div className="quote-action-cell"><Skeleton width={24} height={24} /></div>
  </div>
);

export default React.memo(QuotationReferenceRowSkeleton);
